"use strict";
import { useState, useEffect } from "react";
import { createPortal } from "react-dom";
function Portal({
  children,
  getContainer = () => document.body
}) {
  const [container, setContainer] = useState(null);
  useEffect(() => {
    setContainer(getContainer());
  }, []);
  return container && createPortal(children, container);
}
export {
  Portal
};
